/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { Tooltip } from "@mui/material";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export default function TicketPurchaseTabTooltip() {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        <Trans
          i18nKey="tickets_service.home_tooltip"
          components={[
            <a
              rel="noreferrer"
              href={t("tickets_service.home_tooltip_link")}
              target="_blank"
              style={{
                fontSize: "inherit",
                fontFamily: "inherit",
                textDecoration: "underline",
                color: "#EF60A3",
                background: "none",
                border: "none",
                padding: 0,
                font: "inherit",
                cursor: "pointer",
              }}
            />,
          ]}
        />
      }
    >
      <InfoRoundedIcon
        sx={{ color: "rgba(63, 42, 85, 1)", marginLeft: "8px" }}
      />
    </Tooltip>
  );
}
